import { Util } from '@/utils/utils';
import { Constants } from '@/constants/constants';
import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import { useNavigate } from 'react-router';
import { NAV_PATH } from '@/router/constants';

interface NoticeDetailContent {
	anncmtTitl: string;
	viewDt?: string;
	regDt: string;
	anncmtCtnt: string;
	nextAnncmtId?: string;
	prevAnncmtId?: string;
	nextAnncmtTitl?: string;
	prevAnncmtTitl?: string;
}

export const useNoticeDetail = () => {
	const navigate = useNavigate();

	const noticeDetailInit = (): void => {
		noticeDetailScrollReset();
		noticeDetailGetParams();
	};

	// 리스트 스크롤 위치값 제거
	const noticeDetailScrollReset = (): void => {
		const scrollTop = parseFloat(sessionStorage.getItem('noticeScrollTop') || '0');
		if (!Util.isNullOrEmpty(scrollTop)) {
			sessionStorage.removeItem('noticeScrollTop');
		}
	};

	// 파라미터 가져오기
	const noticeDetailGetParams = (): void => {
		const params = Util.getUrlParameter();
		const anncmtId = params.anncmtId;
		if (!Util.isNullOrEmpty(anncmtId)) {
			noticeDetailGetData(anncmtId);
		}
	};

	// 상세 정보 입력
	const noticeDetailSetInfo = (content: NoticeDetailContent): void => {
		const titleElement = document.querySelector('.board-detail .detail-head .title');
		if (titleElement) {
			titleElement.innerHTML = content.anncmtTitl;
		}

		const regDt =
			content.viewDt && !Util.isNullOrEmpty(content.viewDt)
				? content.viewDt.split(Constants.space)[0]
				: content.regDt.split(Constants.space)[0];
		const strDt = regDt.split('-').join('');

		const dateElement = document.querySelector('.board-detail .detail-head .date');
		if (dateElement) {
			dateElement.innerHTML = Util.convertDate(strDt, '.');
		}

		const textBoxElement = document.querySelector('.board-detail .detail-body .text-box');
		if (textBoxElement) {
			textBoxElement.innerHTML = content.anncmtCtnt;
		}

		const nextBtn = document.querySelector<HTMLAnchorElement>('.detail-next-btn');
		const nextBtnTitle = document.querySelector('.detail-next-btn .title');
		if (nextBtn && nextBtnTitle) {
			noticeDetailSetPrevNext(content, nextBtn, nextBtnTitle, true);
		}

		const prevBtn = document.querySelector<HTMLAnchorElement>('.detail-prev-btn');
		const prevBtnTitle = document.querySelector('.detail-prev-btn .title');
		if (prevBtn && prevBtnTitle) {
			noticeDetailSetPrevNext(content, prevBtn, prevBtnTitle, false);
		}

		noticeDetailShowContents();
	};

	// 이전 다음글 셋팅
	const noticeDetailSetPrevNext = (
		content: NoticeDetailContent,
		btn: HTMLAnchorElement,
		title: Element,
		isNext: boolean
	): void => {
		const className = isNext ? 'first' : 'last';
		const anncmtId = isNext ? content.nextAnncmtId : content.prevAnncmtId;
		if (!Util.isNullOrEmpty(anncmtId)) {
			const link = `${NAV_PATH.CUSTOMER_SUPPORT.NOTICE_DETAIL}?anncmtId=${anncmtId}`;
			btn.setAttribute('to', link);
			title.innerHTML = isNext ? content.nextAnncmtTitl || '' : content.prevAnncmtTitl || '';

			btn.addEventListener('click', e => {
				e.preventDefault();
				navigate(link);
				scrollTo(0, 0);
			});

			title.classList.remove(className);
		} else {
			title.innerHTML = isNext ? '다음글이 없습니다.' : '이전글이 없습니다.';
			title.classList.add(className);
		}
	};

	// 상세 데이터 조회
	const noticeDetailGetData = async (anncmtId: string): Promise<void> => {
		const jsonData = { anncmtId };
		const response = await Remote.Api.get(ApiConstant.mgmtAnncmt.detail, jsonData);

		if (response.code !== Constants.apiSuccess) {
			alert(response.message);
			return;
		}

		if (Util.isNullOrEmpty(response.content)) {
			alert('게시글이 존재하지 않습니다.');
			noticeDetailClickGoList();
		} else {
			noticeDetailSetInfo(response.content);
		}
	};

	// 리스트 페이지로 가기
	const noticeDetailClickGoList = (): void => {
		const params = Util.getUrlParameter();
		const page = Util.isNullOrEmpty(params.page) ? Constants.empty : params.page;
		// location.href = `/views/notice.html?page=${page}`;
		navigate(`${NAV_PATH.CUSTOMER_SUPPORT.NOTICE}?page=${page}`);
	};

	// 컨텐츠 보여주기
	const noticeDetailShowContents = (): void => {
		document.querySelector('.notice .sub-content')?.classList.remove('hidden');
		document.querySelector('.footer')?.classList.remove('hidden');
	};

	// 초기화 실행
	(() => {
		noticeDetailInit();
	})();

	return {
		noticeDetailClickGoList
	};
};
